import React from 'react'

import Center from '../../packages/kiti/components/helpers/Center'
import FullPageTemplate from '../../components/templates/FullPageTemplate'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Panel from '../../packages/kiti/components/structure/Panel'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../packages/kiti/components/presentation/Text'

const FullPageMessage = ({ icon, iconColor, type, title, description, children }) => {
  const isErrorMessage = type === 'error'
  icon = icon || isErrorMessage ? 'RiAlertLine' : 'RiCheckboxCircleLine'
  iconColor = iconColor || isErrorMessage ? 'red' : 'green'

  return (
    <FullPageTemplate>
      <Center height="100vh">
        <Panel open={true} maxWidth={30} minWidth={30} noOverlay>
          <Separator weight={4} />
          <Center>
            <Icon name={icon} size={2} color={iconColor} />
          </Center>
          <Separator weight={4} />
          <Title size="h4" align="center">
            {title}
          </Title>
          {description && <Text align="center">{description} </Text>}
          {children && <Separator weight={2} />}
          {children}
          <Separator weight={4} />
        </Panel>
      </Center>
    </FullPageTemplate>
  )
}

export default FullPageMessage
